import { createSelector } from "reselect";
import { ApplicationState, LanguageState } from "@idw-types/state";

export const getLanguageState = (state: ApplicationState) => {
	return state.language;
};

export const getActiveLanguage = createSelector(getLanguageState, (languageState: LanguageState) => {
	return languageState.activeLanguage;
});

export const getLanguageContent = createSelector(getLanguageState, (languageState: LanguageState) => {
	return languageState.content;
});